import { render } from "./LeftChevronIcon.vue?vue&type=template&id=bf0daa62&scoped=true"
import script from "./LeftChevronIcon.vue?vue&type=script&lang=js"
export * from "./LeftChevronIcon.vue?vue&type=script&lang=js"

import "./LeftChevronIcon.vue?vue&type=style&index=0&id=bf0daa62&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bf0daa62"

export default script